/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createChainClass } from '../../factoriesAny.js';
export var ChainDependencies = {
  typedDependencies,
  createChainClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesChainClass.generated.js
// module id = 527
// module chunks = 2